import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { editSurchargesMaintenance } from 'RestAPIs/admin';

import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

export const useEditMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(editSurchargesMaintenance, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['surchargesMaintenance']
      });
      showSuccessSnackbar();
    },
    onError: (error) => showError(error as AxiosError)
  });

  return { mutateAsync, isLoading };
};
